module.exports = "/assets/60c5ac75bb25880adae962fff2db4028.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WS.png
// module id = 1971
// module chunks = 0